import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import { repository } from '../lib/repository';

export default function Lookbook() {
  const [book, setBook] = useState(null);

  useEffect(() => { repository.getLookbook().then(setBook); }, []);

  if (!book) return <div className="container py-32" />;

  return (
    <div data-testid="page-lookbook">
      <SEO title="Lookbook" description={book.intro} path="/lookbook" image={book.frames[0]?.image} breadcrumb={[{ to: '/', label: 'Home' }, { label: 'Lookbook' }]} />
      {/* Intro */}
      <section className="container py-16 md:py-24">
        <p className="overline text-muted-foreground">{book.season}</p>
        <h1 className="mt-4 font-display text-6xl md:text-9xl leading-[0.85] tracking-tight">{book.title}</h1>
        <p className="mt-8 max-w-xl text-muted-foreground text-lg leading-relaxed">{book.intro}</p>
      </section>

      {/* Frames */}
      <div className="space-y-4 md:space-y-8">
        {book.frames.map((frame, i) => (
          <motion.section
            key={i}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1, ease: [0.85, 0, 0.15, 1] }}
            className="relative"
            data-testid={`lookbook-frame-${i}`}
          >
            <div className={`relative w-full ${i % 2 === 0 ? 'h-[85vh] min-h-[600px]' : 'h-[70vh] min-h-[500px] md:w-4/5 md:ml-auto'} overflow-hidden`}>
              <img src={frame.image} alt={frame.caption} className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-x-0 bottom-0 p-8 md:p-12">
                <p className="overline text-white/85 tabular">FRAME {String(i + 1).padStart(2, '0')} / {String(book.frames.length).padStart(2, '0')}</p>
                <p className="mt-3 font-display text-2xl md:text-4xl text-white max-w-xl leading-tight">{frame.caption}</p>
                <div className="mt-6 flex flex-wrap gap-3">
                  {frame.productSlugs.map((slug) => (
                    <Link
                      key={slug}
                      to={`/product/${slug}`}
                      className="overline bg-white/15 backdrop-blur-md text-white border border-white/40 px-4 py-2 hover:bg-white hover:text-black transition-colors duration-500"
                      data-testid={`lookbook-shop-${slug}`}
                    >
                      Shop the piece
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </motion.section>
        ))}
      </div>

      <div className="container py-24 text-center">
        <p className="overline text-muted-foreground">End of edition</p>
        <p className="mt-6 font-display text-4xl md:text-6xl">Take the mountain with you.</p>
        <Link to="/shop" className="mt-8 inline-block overline link-underline">Shop the Edition</Link>
      </div>
    </div>
  );
}
